import React from 'react'

import { useSurveyContext } from '../_store'

import Layout00 from './_layouts/Layout00'

const LayoutSelector = ({ step }) => {
  const { state } = useSurveyContext()
  const id = state.pages[`step_${step}`].page.layoutId

  const Component = (() => {
    switch (id) {
      default:
        return Layout00
    }
  })()

  return <Component step={step} />
}

export default LayoutSelector
